import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import IrtizaDynamicInputList from '../irtiza-dynamic-input/irtiza-dynamic-input-list';
import SecurityService from '../security/security.service';
import DesignationService from './designation.service';
import AuditTableInput from '../audit-table/audit-table'
import './designation.scss'


const DesignationInput = (props) => {



// DesignationID
// DesignationName
    let columns =[
        {  field: "DesignationID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{allowEditing:false}]},
        {  field: "DesignationName",headerText:'Designation',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        ]

       const listActionComplete = async (grid , args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          // if(args.requestType == 'add'){
          //   setTimeout(()=>document.getElementById('DesignationGridDesignationName').focus(),400)
          // }
          document.getElementById('DesignationGridDesignationName').addEventListener('blur', async (e)=>{
            setTimeout(() => document.getElementById('DesignationGridDesignationName') && grid?.endEdit(), 200);
           
          })
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            id:args.data.DesignationID,
            value:args.data.DesignationName,
            CreationDate:moment().format('DD-MMM-YY'),
            CreatedByUserID:SecurityService.getLoggedInUserId(),
            UpdationDate:	moment().format('DD-MMM-YY'),
            UpdatedByUserID:SecurityService.getLoggedInUserId()
          }
          console.log(data)
        if(args.action == 'add'){
          DesignationService.insert(data).then(async (res)=>{
            await getListService()
            setTimeout(()=>document.getElementById('DesignationGrid_add').click(),700)

            // let AddData = {
            //   DesignationID:args.data.DesignationID,
            //   DesignationName:args.data.DesignationName,
            // }
            // AuditTableInput.auditAdd(`Designation`,`Designation`,`DesignationID`,AddData)
          })
        }
        if(args.action == 'edit'){
          DesignationService.update(data).then((res)=>{
            getListService()

            // let EditData = {
            //     DesignationID:args.data.DesignationID,
            //     DesignationName:args.data.DesignationName
            // }
            // let totalColumns = Object.keys(EditData);
            //             console.log(totalColumns)
            //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`Designation`,args.data.MainDesignationID)
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props?.isDialog ? props.isDialog : false

       
        // Defines the  string
        // @default Designation${typeMode} 
        let ListSecurity='JournalVoucherList'
        let AddSecurity='JournalVoucherList'
        let EditSecurity='JournalVoucherList'
        let DeleteSecurity='JournalVoucherList'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Designation' ,
                    TableID:'DesignationID',
                   // Optional if Delete is Soft // TableSecurity:'DesignationDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Designation' ,TableID:'DesignationID', Optional // TableSecurity:'DesignationDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Normal';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='Designation'
        ListTitle='Designation - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        // DataSource:  ()=> DesignationService.getDesignationForList()
                        DataSource:  ()=> DesignationService.getDesignationForList()
                        }]}
        DefaultSortedColumnName={'DesignationID'}
        // GridDialog={[
        //     {
        //         DialogType:'Self',
        //         Dialog:<DesignationAdd ShopID={SecurityService.getLoggedInShopID()} />
        
        //     }
        // ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}
            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default DesignationInput;
